import React, {Component} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import PropTypes from "prop-types";
import {Formik} from "formik";
import localized from "../../i18n/index"

class ConfirmationModel extends Component {
    render() {
        const {
            onClose,
            isOpen,
            onSubmit,
            title,
            bodyContent,
            submitBtn,
            className,
            disabled,
            initialValues
        } = this.props;
        return (
            <Modal
                centered
                isOpen={isOpen}
                size="md"
                className={className ? className : ""}
            >
                {title && <ModalHeader>{title}</ModalHeader>}
                <Formik
                    initialValues={initialValues}
                    onSubmit={(values,{setSubmitting})=>onSubmit(values,setSubmitting)}
                >
                    {props => {
                        const {handleSubmit, isSubmitting} = props;
                        return (
                            <form onSubmit={handleSubmit}>
                                {bodyContent && <ModalBody> {bodyContent} </ModalBody>}
                                <ModalFooter>
                                    <div className="modal_footer">
                                        <Button className="close_btn" onClick={onClose}>
                                            {localized.cancel}
                                        </Button>
                                        <Button
                                            className={`submit_btn`}
                                            type="submit"
                                            disabled={disabled || isSubmitting}
                                        >
                                            {isSubmitting || disabled ? localized.Loading : submitBtn}
                                        </Button>
                                    </div>
                                </ModalFooter>
                            </form>
                        )
                    }}
                </Formik>
            </Modal>
        );
    }
}

ConfirmationModel.propTypes = {
    title: PropTypes.any,
    bodyContent: PropTypes.any,
    initialValues: PropTypes.object,
    submitBtn: PropTypes.string,
    className: PropTypes.string,
    isOpen: PropTypes.bool,
    disabled: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}

ConfirmationModel.defaultProps = {
    submitBtn: "submit",
    initialValues:{},
}

export default ConfirmationModel;